var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowperformers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.836,
    height: 34.812,
    viewBox: "0 0 34.836 34.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1833",
    "data-name": "Group 1833",
    transform: "translate(0 0)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M477.637,414.4h-6.786a.453.453,0,0,0-.453.453v5.655a.452.452,0,0,0,.453.453h6.786a.453.453,0,0,0,.453-.453v-5.655a.453.453,0,0,0-.453-.453Zm-.453,5.655H471.3v-4.75h5.881Z",
    transform: "translate(-443.254 -386.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M302.851,301.56a.453.453,0,0,0-.453.453v14.771a.453.453,0,0,0,.453.453h6.786a.453.453,0,0,0,.453-.453V302.013a.453.453,0,0,0-.453-.453Zm6.333,14.771H303.3V302.465h5.881Z",
    transform: "translate(-288.826 -282.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M134.851,163.577h6.786a.453.453,0,0,0,.453-.453V134.85a.453.453,0,0,0-.453-.453h-6.786a.453.453,0,0,0-.453.453v28.275a.452.452,0,0,0,.453.453ZM135.3,135.3h5.881v27.371H135.3Z",
    transform: "translate(-134.398 -128.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M203.136,90.676h-2.262a.453.453,0,0,0,0,.905h3.389a.5.5,0,0,0,.176-.036.658.658,0,0,0,.131-.086l.027-.036a.367.367,0,0,0,.068-.095v-.041a.458.458,0,0,0,.05-.158V87.735a.453.453,0,1,0-.905,0V90.07L177.43,64.789a.452.452,0,0,0-.624.651Z",
    transform: "translate(-173.273 -64.686)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowperformers);
export default __webpack_public_path__ + "static/media/Lowperformers.cf89fb012699086c30bbbe458047b20e.svg";
export { ForwardRef as ReactComponent };